import { NativeEvent } from '../NativeEvent';

export interface AppsflyerPayload {
  eventName: string;
  eventValues: Record<string, unknown>;
}

/** Dispara um evento de tracking via AppsFlyer no app nativo. */
export class AppsflyerEvent extends NativeEvent<'appsflyer', AppsflyerPayload> {
  readonly type = 'appsflyer';
  readonly payload: AppsflyerPayload;

  constructor(eventName: string, eventValues: Record<string, unknown> = {}) {
    super();
    this.payload = { eventName, eventValues };
  }

  protected override validate(): void {
    if (!this.payload.eventName) {
      throw new Error('AppsflyerEvent: eventName é obrigatório');
    }
  }
}
